import { FC } from 'react'
import { SyfLoader } from 'syf-component-library/ui/atoms'
import styled from 'styled-components'

const LoadingWrapper = styled.div`
  z-index: 999;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
`
const FullPageLoad: FC = () => {
  return (
    <LoadingWrapper>
      <SyfLoader size={5} />
    </LoadingWrapper>
  )
}

export default FullPageLoad
